import React from 'react';
import { Row, Col } from 'react-bootstrap';
import { Link } from 'gatsby';
import Thumbnail from './Thumbnail';
import Title from '../Title';
import specialtiesContent from '../../consts/specialties-content';

const childrenSpecialties = [
  'terapia-aba',
  'fonoaudiologia',
  'musicoterapia',
  'psicomotricidade',
  'psicopedagogia',
  'psicologia-infantil',
  'terapia-ocupacional',
];

const adultsAndChildrenSpecialties = [
  'avaliacao-neuropsicologica',
  'psicoterapia',
  'fonoaudiologia',
  'psicopedagogia',
  'avaliacao-bariatrica-etc',
  'avaliacao-psicossocial',
  'orientacao-vocacional',
];

// eslint-disable-next-line react/prop-types
const SpecialtiesGrid = ({ names }) => (
  <Row className="no-gutters">
    {names.map((name) => (
      <Col md="3" xs="12" key={name}>
        <Link to={`/servico/${name}`}>
          <Thumbnail
            text={specialtiesContent[name].title}
            imageUrl={specialtiesContent[name].images[0]}
          />
        </Link>
      </Col>
    ))}
  </Row>
);

const Specialties = () => (
  <>
    <section id="specialties">
      <Title color="#186492" text="Crianças" />
      <SpecialtiesGrid names={childrenSpecialties} />
    </section>

    <section id="specialties-adultos">
      <Title color="#186492" text="Adultos e Crianças" />
      <SpecialtiesGrid names={adultsAndChildrenSpecialties} />
    </section>
  </>
);

export default Specialties;
